export const COMPARTMENT_GLOBALS = [
    'AggregateError',
    'Array',
    'ArrayBuffer',
    'BigInt',
    'BigInt64Array',
    'BigUint64Array',
    'Boolean',
    'DataView',
    'Date',
    'Error',
    'EvalError',
    'Infinity',
    'Int16Array',
    'Int32Array',
    'Int8Array',
    'Iterator',
    'JSON',
    'Map',
    'Math',
    'NaN',
    'Number',
    'Object',
    'Promise',
    'Proxy',
    'RangeError',
    'ReferenceError',
    'Reflect',
    'RegExp',
    'Set',
    'String',
    'Symbol',
    'SyntaxError',
    'TextDecoder',
    'TextEncoder',
    'TypeError',
    'URIError',
    'Uint16Array',
    'Uint32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'WeakMap',
    'WeakSet',
    'decodeURI',
    'decodeURIComponent',
    'encodeURI',
    'encodeURIComponent',
    'escape',
    'globalThis',
    'isFinite',
    'isNaN',
    'parseFloat',
    'parseInt',
    'undefined',
    'unescape'
];
export const SANDBOX_CAPABILITIES = [
    '_',
    'Intl',
    'URL',
    'URLSearchParams',
    'atob',
    'btoa',
    'clearInterval',
    'clearTimeout',
    'console',
    'crypto',
    'fetch',
    'setInterval',
    'setTimeout'
];
export const SANDBOX_GLOBALS = new Set([...COMPARTMENT_GLOBALS, ...SANDBOX_CAPABILITIES]);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2FuZGJveEdsb2JhbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvc2VzL3NhbmRib3hHbG9iYWxzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU9BLE1BQU0sQ0FBQyxNQUFNLG1CQUFtQixHQUFHO0lBQy9CLGdCQUFnQjtJQUNoQixPQUFPO0lBQ1AsYUFBYTtJQUNiLFFBQVE7SUFDUixlQUFlO0lBQ2YsZ0JBQWdCO0lBQ2hCLFNBQVM7SUFDVCxVQUFVO0lBQ1YsTUFBTTtJQUNOLE9BQU87SUFDUCxXQUFXO0lBQ1gsVUFBVTtJQUNWLFlBQVk7SUFDWixZQUFZO0lBQ1osV0FBVztJQUNYLFVBQVU7SUFDVixNQUFNO0lBQ04sS0FBSztJQUNMLE1BQU07SUFDTixLQUFLO0lBQ0wsUUFBUTtJQUNSLFFBQVE7SUFDUixTQUFTO0lBQ1QsT0FBTztJQUNQLFlBQVk7SUFDWixnQkFBZ0I7SUFDaEIsU0FBUztJQUNULFFBQVE7SUFDUixLQUFLO0lBQ0wsUUFBUTtJQUNSLFFBQVE7SUFDUixhQUFhO0lBQ2IsYUFBYTtJQUNiLGFBQWE7SUFDYixXQUFXO0lBQ1gsVUFBVTtJQUNWLGFBQWE7SUFDYixhQUFhO0lBQ2IsWUFBWTtJQUNaLG1CQUFtQjtJQUNuQixTQUFTO0lBQ1QsU0FBUztJQUNULFdBQVc7SUFDWCxvQkFBb0I7SUFDcEIsV0FBVztJQUNYLG9CQUFvQjtJQUNwQixRQUFRO0lBQ1IsWUFBWTtJQUNaLFVBQVU7SUFDVixPQUFPO0lBQ1AsWUFBWTtJQUNaLFVBQVU7SUFDVixXQUFXO0lBQ1gsVUFBVTtDQUNiLENBQUM7QUFXRixNQUFNLENBQUMsTUFBTSxvQkFBb0IsR0FBRztJQUNoQyxHQUFHO0lBQ0gsTUFBTTtJQUNOLEtBQUs7SUFDTCxpQkFBaUI7SUFDakIsTUFBTTtJQUNOLE1BQU07SUFDTixlQUFlO0lBQ2YsY0FBYztJQUNkLFNBQVM7SUFDVCxRQUFRO0lBQ1IsT0FBTztJQUNQLGFBQWE7SUFDYixZQUFZO0NBQ2YsQ0FBQztBQUdGLE1BQU0sQ0FBQyxNQUFNLGVBQWUsR0FBd0IsSUFBSSxHQUFHLENBQUMsQ0FBQyxHQUFHLG1CQUFtQixFQUFFLEdBQUcsb0JBQW9CLENBQUMsQ0FBQyxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBUaGUgbmFtZXMgYSBTRVMgY29tcGFydG1lbnQgcHJvdmlkZXMgb25jZSBgY3JlYXRlU2FuZGJveGAgaGFzIHJlbW92ZWQgd2hhdCBpdCByZW1vdmVzLlxuICogYGV2YWxgLCBgRnVuY3Rpb25gLCBgQ29tcGFydG1lbnRgLCBgbG9ja2Rvd25gIGFuZCBgaGFyZGVuYCBhcmUgZGVsaWJlcmF0ZWx5IGFic2VudC5cbiAqXG4gKiBBIGxpc3QgcmF0aGVyIHRoYW4gYSBkZXJpdmVkIHNldCwgYmVjYXVzZSB0aGUgY2hlY2sgYWxzbyBydW5zIGluIHRoZSBicm93c2VyLCB3aGVyZSB0aGVyZVxuICogaXMgbm8gY29tcGFydG1lbnQgdG8gYXNrLiBBIHRlc3Qga2VlcHMgaXQgaW4gc3RlcCB3aXRoIGEgcmVhbCBvbmUuXG4gKi9cbmV4cG9ydCBjb25zdCBDT01QQVJUTUVOVF9HTE9CQUxTID0gW1xuICAgICdBZ2dyZWdhdGVFcnJvcicsXG4gICAgJ0FycmF5JyxcbiAgICAnQXJyYXlCdWZmZXInLFxuICAgICdCaWdJbnQnLFxuICAgICdCaWdJbnQ2NEFycmF5JyxcbiAgICAnQmlnVWludDY0QXJyYXknLFxuICAgICdCb29sZWFuJyxcbiAgICAnRGF0YVZpZXcnLFxuICAgICdEYXRlJyxcbiAgICAnRXJyb3InLFxuICAgICdFdmFsRXJyb3InLFxuICAgICdJbmZpbml0eScsXG4gICAgJ0ludDE2QXJyYXknLFxuICAgICdJbnQzMkFycmF5JyxcbiAgICAnSW50OEFycmF5JyxcbiAgICAnSXRlcmF0b3InLFxuICAgICdKU09OJyxcbiAgICAnTWFwJyxcbiAgICAnTWF0aCcsXG4gICAgJ05hTicsXG4gICAgJ051bWJlcicsXG4gICAgJ09iamVjdCcsXG4gICAgJ1Byb21pc2UnLFxuICAgICdQcm94eScsXG4gICAgJ1JhbmdlRXJyb3InLFxuICAgICdSZWZlcmVuY2VFcnJvcicsXG4gICAgJ1JlZmxlY3QnLFxuICAgICdSZWdFeHAnLFxuICAgICdTZXQnLFxuICAgICdTdHJpbmcnLFxuICAgICdTeW1ib2wnLFxuICAgICdTeW50YXhFcnJvcicsXG4gICAgJ1RleHREZWNvZGVyJyxcbiAgICAnVGV4dEVuY29kZXInLFxuICAgICdUeXBlRXJyb3InLFxuICAgICdVUklFcnJvcicsXG4gICAgJ1VpbnQxNkFycmF5JyxcbiAgICAnVWludDMyQXJyYXknLFxuICAgICdVaW50OEFycmF5JyxcbiAgICAnVWludDhDbGFtcGVkQXJyYXknLFxuICAgICdXZWFrTWFwJyxcbiAgICAnV2Vha1NldCcsXG4gICAgJ2RlY29kZVVSSScsXG4gICAgJ2RlY29kZVVSSUNvbXBvbmVudCcsXG4gICAgJ2VuY29kZVVSSScsXG4gICAgJ2VuY29kZVVSSUNvbXBvbmVudCcsXG4gICAgJ2VzY2FwZScsXG4gICAgJ2dsb2JhbFRoaXMnLFxuICAgICdpc0Zpbml0ZScsXG4gICAgJ2lzTmFOJyxcbiAgICAncGFyc2VGbG9hdCcsXG4gICAgJ3BhcnNlSW50JyxcbiAgICAndW5kZWZpbmVkJyxcbiAgICAndW5lc2NhcGUnXG5dO1xuXG4vKipcbiAqIFdoYXQgdGhlIHNhbmRib3ggc3VwcGxpZXMgb24gdG9wIG9mIGEgY29tcGFydG1lbnQncyBvd24gaW50cmluc2ljcy4gYEludGxgIGlzIGhlcmUgcmF0aGVyXG4gKiB0aGFuIGFib3ZlIGJlY2F1c2UgU0VTIGRvZXMgbm90IGNhcnJ5IGl0IGF0IGFsbCwgYW5kIGBEYXRlYCBhbmQgYE1hdGhgIGFyZSBub3QsIGJlY2F1c2UgYVxuICogY29tcGFydG1lbnQgaGFzIGJvdGggYWxyZWFkeTogdGhlIHNhbmRib3ggcmVwbGFjZXMgdGhlbSB3aXRoIHZlcnNpb25zIHRoYXQgd29yay5cbiAqXG4gKiBgZmV0Y2hgIGRlcGVuZHMgb24gdGhlIGNhbGxlciBncmFudGluZyBuZXR3b3JrIGFjY2VzcywgYW5kIGlzIHRoZSBvbmUgbmFtZSBoZXJlIHRoYXQgYVxuICogc2NyaXB0IGNhbiBiZSByZWZ1c2VkLiBUaGUgY2hlY2sgc3RpbGwgYWNjZXB0cyBpdCwgc28gdGhhdCBhbiBleHByZXNzaW9uIHJlYWRzIHRoZSBzYW1lXG4gKiB3aGljaGV2ZXIgY2FsbGVyIHJ1bnMgaXQuXG4gKi9cbmV4cG9ydCBjb25zdCBTQU5EQk9YX0NBUEFCSUxJVElFUyA9IFtcbiAgICAnXycsXG4gICAgJ0ludGwnLFxuICAgICdVUkwnLFxuICAgICdVUkxTZWFyY2hQYXJhbXMnLFxuICAgICdhdG9iJyxcbiAgICAnYnRvYScsXG4gICAgJ2NsZWFySW50ZXJ2YWwnLFxuICAgICdjbGVhclRpbWVvdXQnLFxuICAgICdjb25zb2xlJyxcbiAgICAnY3J5cHRvJyxcbiAgICAnZmV0Y2gnLFxuICAgICdzZXRJbnRlcnZhbCcsXG4gICAgJ3NldFRpbWVvdXQnXG5dO1xuXG4vKiogRXZlcnkgbmFtZSBhIHNjcmlwdCBjYW4gcmVhY2ggd2l0aG91dCB0aGUgY2FsbGVyIHB1dHRpbmcgaXQgaW4gc2NvcGUuICovXG5leHBvcnQgY29uc3QgU0FOREJPWF9HTE9CQUxTOiBSZWFkb25seVNldDxzdHJpbmc+ID0gbmV3IFNldChbLi4uQ09NUEFSVE1FTlRfR0xPQkFMUywgLi4uU0FOREJPWF9DQVBBQklMSVRJRVNdKTtcbiJdfQ==